import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDuplicate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M15.75 10c0-1.077-.098-2.141-.217-3.204a2.38 2.38 0 0 0-2.094-2.09c-1.057-.113-2.117-.206-3.189-.206s-2.132.093-3.189.206a2.38 2.38 0 0 0-2.094 2.09C4.848 7.859 4.75 8.923 4.75 10s.098 2.141.217 3.204a2.38 2.38 0 0 0 2.094 2.09c1.057.113 2.117.206 3.189.206s2.132-.093 3.189-.206a2.38 2.38 0 0 0 2.094-2.09c.119-1.063.217-2.127.217-3.204m1.274-3.37c.12 1.076.226 2.207.226 3.37s-.106 2.294-.226 3.37a3.88 3.88 0 0 1-3.426 3.416c-1.07.114-2.194.214-3.348.214s-2.278-.1-3.348-.214a3.88 3.88 0 0 1-3.426-3.416c-.12-1.076-.226-2.207-.226-3.37s.106-2.294.226-3.37a3.88 3.88 0 0 1 3.426-3.416C7.972 3.1 9.096 3 10.25 3s2.278.1 3.348.214a3.88 3.88 0 0 1 3.426 3.416"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.25 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M13.5 10a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 .75.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDuplicate;
